// extracted by mini-css-extract-plugin
export default {"label":"styles_label__y6j9j","pointer":"styles_pointer__wiZTP"};